import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { firstValueFrom } from 'rxjs';
import { AuthLoginService } from 'src/app/pages/login/services/auth-login.service';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.css'],
})
export class ButtonComponent {
  @Input('name') name = '';
  @Input('icon') icon!: IconProp;
  @Input('ruta') ruta!: string;
  @Input('lob') lob!: string;
  @Input('ruta-relativa') rRelativa!: string;
  @Input('prime-icon') prime_icon!: string;

  @Input('permisos') permisos: string[] = [];

  ngOnInit() {
    this.checkPermisos();
  }

  constructor(
    private readonly auth: AuthLoginService,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) { }

  readonly = false;

  async checkPermisos() {
    const userState = await this.auth.returnUserInfoV2('LOADED');

    if (!userState) return;

    if (userState.user.superuser) {
      this.readonly = false;
    } else {
      if (this.permisos.length > 0) {
        this.readonly = !this.permisos.some((item) =>
          userState.user.permission?.some((p) => p.name === item)
        );
      } else if (this.lob) {
        if (userState.user.lob) {
          this.readonly = !userState.user.lob.some(
            (lob) => lob.name === this.lob
          );
        }
      }
    }
  }
  // async checkPermisos() {

  //   const user = (await this.auth.returnUserInfo()) as UserI;

  //   // Superusuario: acceso total
  //   if (user?.superuser) {
  //     this.readonly = false;
  //     return;
  //   }



  //##Funciona pero aun no lo subi
  // Si el botón requiere permisos
  // if (this.permisos?.length > 0) {

  // const tieneAcceso = user?.permission?.some((permiso: any) => {

  // Primero verificamos que tenga el permiso
  // if (!this.permisos.includes(permiso.name)) {
  //   return false;
  // }

  // Si además el botón tiene una LOB,
  // el permiso debe pertenecer a esa LOB
  // if (this.lob) {

  //   return permiso.lob?.some(
  //     (lob: any) => lob.name === this.lob
  //   );

  // }

  // Si no se especificó LOB,
  // alcanza con tener el permiso
  //   return true;

  // });

  //   this.readonly = !tieneAcceso;
  //   return;
  // }

  // Si el botón solamente depende de la LOB
  // if (this.lob) {

  //   const tieneLob = user?.lob?.some(
  //     (lob: any) => lob.name === this.lob
  //   );

  //   this.readonly = !tieneLob;
  //   return;
  // }

  // Sin restricciones
  //   this.readonly = false;
  // }

  async navigate() {
    const lob = (await firstValueFrom(this.route.paramMap)).get('name');
    this.router.navigate([
      this.ruta ? 'home/line-of-business/' + lob + this.ruta : this.rRelativa,
    ]);
  }
}
